import { motion } from '@carbon/motion';
import { MotionName, MotionMode } from '@upright/ui/common/generic/motion/types';
import styled, { keyframes } from 'styled-components';

interface Props {
  className?: string;
  size?: number | string;
  color?: string;
}

export const SuccessCheckmark = (props: Props) => {
  const size = props.size || '1em';
  const color = props.color || 'inherit';
  return (
    <CheckmarkContainer
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      fillColor={color}
      className={props.className}
    >
      <CheckmarkCircle cx="26" cy="26" r="25" fill="none" color={color} />
      <CheckmarkLine fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" color={color} />
    </CheckmarkContainer>
  );
};

const curve = motion(MotionName.STANDARD, MotionMode.EXPRESSIVE);

const stroke = keyframes`
  100% {
    stroke-dashoffset: 0;
  }
`;

const CheckmarkContainer = styled.svg<{ fillColor: string }>`
  border-radius: 50%;
  display: block;
  stroke-width: 4;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px ${props => props.fillColor};
`;

const CheckmarkCircle = styled.circle<{ color: string }>`
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 10;
  stroke-miterlimit: 10;
  stroke: ${props => props.color};
  animation: ${stroke} 0.6s ${curve} forwards;
`;

const CheckmarkLine = styled.path<{ color: string }>`
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke-width: 6;
  animation: ${stroke} 0.3s ${curve} 0.8s forwards;
  stroke: ${props => props.color};
`;
